import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as styles from "./styles.css";
const toChecker = (match) => (to) => to.indexOf(match) > -1;
const isEmailLink = toChecker("mailto:");
export const SmartLink = ({ children, classNameM = M.empty(), link, onClickM = M.empty(), keyM = M.empty(), targetM = M.empty(), id, }) => {
    const isSelf = isEmailLink(link.to) || link.kind === "internal";
    const target = M.fromMaybe(targetM, isSelf ? "_self" : "_blank");
    return (React.createElement("a", { key: M.fromMaybe(keyM, undefined), className: cn(styles.link, classNameM), target: target, onClick: M.fromMaybe(onClickM, () => { }), href: link.to, id: id }, children));
};

